import CopyIcon from '@atlaskit/icon/core/copy';
import * as React from 'react';

export function SvgCopy() {
  return <CopyIcon label="" testId="ads-refreshed-icon" />;
}
